type TokenGetter = () => Promise<string>;

let auth0TokenGetter: TokenGetter | null = null;

export const setAuth0TokenGetter = (getter: TokenGetter) => {
  auth0TokenGetter = getter;
};

export const getAuth0Token = async (): Promise<string | null> => {
  if (auth0TokenGetter) {
    try {
      return await auth0TokenGetter();
    } catch (error) {
      console.error('Error getting Auth0 token:', error);
      return null;
    }
  }
  return null;
};

export const getAccessToken = async () => {
  const auth0Token = await getAuth0Token();
  if (auth0Token) {
    return auth0Token;
  }

  const token = localStorage.getItem('authToken');
  if (token) {
    return token;
  } else {
    console.error('No access token found in localStorage');
    return null;
  }
};

export const clearTokenInfo = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('expireToken');
};
